import React from 'react';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useIntl } from 'react-intl';

import Stack from '@mui/material/Stack';

import Form, { FormTextField } from '@ts-core/core/components/FormV2';

import { DocumentFormInput } from '../../types';

const DocumentFormSchema = Yup.object({
  name: Yup.string().required('El nombre es requerido'),
  url: Yup.string().url('La url es inválida'),
});

export interface UpdateDocumentFormProps {
  onSubmit: (data: DocumentFormInput) => void;

  isExternal: boolean;
  documentFormData?: DocumentFormInput;
  isSubmitting: boolean;
  submitError?: string;
}

const UpdateDocumentForm = (props: UpdateDocumentFormProps) => {
  const { documentFormData, isSubmitting, submitError, isExternal, onSubmit } = props;
  const intl = useIntl();

  const { handleSubmit, formState, control } = useForm<DocumentFormInput>({
    resolver: yupResolver(DocumentFormSchema),
    defaultValues: documentFormData,
  });

  return (
    <Form sx={{ width: '100%' }} onSubmit={handleSubmit(onSubmit)} isSubmitting={isSubmitting} submitError={submitError} formState={formState}>
      <Stack spacing={2}>
        <FormTextField
          control={control}
          type="text"
          rules={{ required: true }}
          name="name"
          label={intl.formatMessage({ id: 'field.name.label' })}
          fullWidth
        />
        {isExternal && (
          <FormTextField
            control={control}
            type="text"
            rules={{ required: true }}
            name="url"
            label={intl.formatMessage({ id: 'field.name.label' })}
            fullWidth
          />
        )}
      </Stack>
    </Form>
  );
};

export default UpdateDocumentForm;
